import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import {
  ChangeLog,
  SubmissionApproval,
  SubmissionApprovalRequest,
  SubmissionRequest,
  Approvals,
  Submission,
} from '../../../../shared/models/flow-manager-core';
import { map, timeout } from 'rxjs/operators';
import orderBy from 'lodash/orderBy';

enum SubmissionState {
  APPROVED = 1,
  DECLINED = 2,
  PENDING = 3,
  DEPLOYED = 4,
}

@Injectable()
export class SubmissionService {
  private static readonly baseUri: string =
    environment.controlBaseUrl + environment.submissionBaseUri;

  constructor(private http: HttpClient) {}

  createSubmission(env: string, submissionRequest: SubmissionRequest): Observable<Boolean> {
    return this.http.post<Boolean>(this.createUri([env, 'create']), submissionRequest);
  }

  getSubmissions(): Observable<Array<Approvals>> {
    return this.http.get<Array<Approvals>>(this.createUri(['all']));
  }

  getSubmissionsBySubmissionState(submissionState: string): Observable<Array<Submission>> {
    return this.http
      .get<Array<Submission>>(this.createUri(['status', SubmissionState[submissionState]]))
      .pipe(map((x) => orderBy(x, ['cdcUpdateTimestamp'], ['desc'])));
  }

  getMyApprovals(): Observable<Array<Submission>> {
    return this.http
      .get<Array<Submission>>(this.createUri(['myapprovals']))
      .pipe(map((x) => orderBy(x, ['cdcUpdateTimestamp'], ['desc'])));
  }

  actionSubmission(submissionApproval: SubmissionApprovalRequest): Observable<Boolean> {
    return this.http
      .post<Boolean>(this.createUri(['approval', 'action']), submissionApproval)
      .pipe(timeout(5000));
  }

  getUserSubmissionApprovals(): Observable<Array<SubmissionApproval>> {
    return this.http.get<Array<SubmissionApproval>>(this.createUri(['user', 'approvals']));
  }

  getChangeLog(env: string, id: string): Observable<Array<ChangeLog>> {
    return this.http.get<Array<ChangeLog>>(this.createUri([env, id, 'changelog']));
  }

  deployToProd(
    env: string,
    submissionApprovalRequest: SubmissionApprovalRequest
  ): Observable<Boolean> {
    return this.http
      .post<Boolean>(this.createUri([env, 'deploy']), submissionApprovalRequest)
      .pipe(timeout(5000));
  }

  getSubmissionApprovals(submissionId: string): Observable<SubmissionApproval> {
    return this.http.get<SubmissionApproval>(this.createUri([submissionId, 'status']));
  }

  getSubmissionsCount(): Observable<SubmissionApproval> {
    return this.http.get<SubmissionApproval>(this.createUri(['count']));
  }

  private createUri(paths: any[]): string {
    let finalUrl = SubmissionService.baseUri;
    paths.forEach((path) => {
      finalUrl = finalUrl.concat('/').concat(path);
    });
    return finalUrl;
  }
}
